import { z } from "zod";

export const LoginFormSchema = z.object({
  email: z.string().min(1, "メールアドレスを入力してください"),
  password: z.string().min(1, "パスワードを入力してください"),
});

export type LoginFormData = z.infer<typeof LoginFormSchema>;
